export default "https://legacy.eskolare-development.com/images/glyphs-right.png";